<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Documentos de Conteo de mercancias</ModuleHeader>
      <v-card class="mb-5" flat>
        Filtrar por fecha
        <v-card-text class="ma-1">
          <v-row>
            <v-col md="5" cols="12">
              <label>Fecha inicial</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDate(date, 1)"
                :value="input_date.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="5" cols="12">
              <label>Fecha final</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDateFinal(date, 1)"
                :disabled-dates="disableDates"
                :value="input_date_final.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="2" cols="12" class="text-center align-content-center">
              <v-btn color="success" @click="getDocuments()"> Buscar </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <modal v-model="showModal" :showFooter="false" title="Agregar Categoria">
    </modal>
  </div>
</template>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import Datepicker from "vuejs-datepicker";

export default {
  name: "DocumentosCRUD",
  components: {
    modal,
    uvDataTable,
    Datepicker,
  },
  props: [],
  data() {
    return {
      input_date: new moment(),
      input_date_final: new moment(),

      origenes: [],
      self: this,
      showModal: false,
      formKey: 0,
      Documentos: [],
      formIndex: 0,
      editMode: false,
      showCreator: false,
      editData: [],
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nuevo Conteo de Mercancias",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Abrir documento",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          /*{
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Documento de mercancias",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
            format: (row) => {
              return (
                "<b>" +
                row["Fecha"] +
                "</b><br/>" +
                '<b style="color:green;">' +
                row["CreadoPor"] +
                "</b>"
              );
            },
          },
          {
            text: "Ultima actualización",
            value: "FechaUpa",
            format: (row) => {
              return (
                "<b>" +
                row["FechaUpa"] +
                "</b><br/>" +
                '<b style="color:green;">' +
                row["ActualizadoPor"] +
                "</b>"
              );
            },
          },
          {
            text: "Departamento",
            value: "Departamento",
            canBeFiltered: true,
          },

          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["Status"] == "Completado") {
                return '<b style="color:green;">' + row["Status"] + "</b>";
              } else {
                return '<b style="color:orange;">' + row["Status"] + "</b>";
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        //this.createDocument();
        this.$router.push({ path: "/productos-inventarios/documentoConteo" });
      }
      if (buttonId == "editDocumentRecepcion") {
        this.$router.push({
          path: "/productos-inventarios/documentoConteo/" + idSelected,
        });
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }
    },
    async createDocument() {
      this.$swal({
        title: "¿Deseas crear un nuevo documento de Conteo de mercancias?",
        text: "Al crear el documento podras agregar los productos necesarios para ingresar a inventario",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Crear Documento",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento Creado",
              "El documento se creo correctamente",
              "success"
            );
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.id,
            });
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        alert("Creando");
        this.$pgsHelper.log(data);
      } else if (doAction == "EDIT") {
        alert("editando");
        this.$pgsHelper.log(data);
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      if (docu.Aplicado) {
        this.$swal(
          "No puedes eliminar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas el documento de entrada de mercancias?",
        text: "Al eliminarlo se perderan todos los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-eliminarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = this.input_date;
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getDocuments() {
      const fechaInicio = moment(this.input_date.format("YYYY-MM-DD")+ " 00:00").valueOf();
      const fechaFin = moment(this.input_date_final).endOf("day").valueOf();

      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      try {
        const data = await firestore.queryBuilder("AMC_ConteosInventario", [
          firestore.where(
            "tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
          firestore.where("mta.cra.t", ">=", fechaInicio),
          firestore.where("mta.cra.t", "<=", fechaFin),
        ]);

        // // console.log(data)
        // this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
        let document = data.docs.map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        });

        document.forEach((data) => {
          let fecha = null;
          let fechaUpa = null;
          let updatedBy = "";
          let createdBy = "";
          if (data.mta.cra) {
            fecha = new moment(data.mta.cra.t);
            createdBy = data.mta?.cra?.u?.n;
          }
          if (data.mta.upa) {
            fechaUpa = new moment(data.mta.upa.t);
            updatedBy = data.mta?.upa?.u?.n;
          }

          let origenData = this.getOrigenById(data.amc);
          this.Documentos.push({
            id: data.id,
            origenId: data.amc,
            origenNombre: origenData.Nombre,
            Nombre: "Conteo - " + data.id,
            Fecha: fecha ? fecha.format("YYYY-MM-DD HH:mm") : "",
            FechaUpa: fechaUpa ? fechaUpa.format("YYYY-MM-DD HH:mm") : "",
            ActualizadoPor: updatedBy,
            CreadoPor: createdBy,
            Departamento: data.dpt,
            stc: data.sts,
            Status: data.sts == "A" ? "Completado" : "Pendiente",
          });
        });

        this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
      } catch (error) {
        console.error("Error: ", error);
      }
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
      this.getDocuments();
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    disableDates() {
      return { to: moment(this.input_date).toDate() };
    },
  },
  watch: {},
  mounted() {},
  async created() {
    await this.getOrigenes();
    //await this.getDocuments();
  },
};
</script>
